
const pearsonLightTheme = {
  tabs: {

  },
  buttons: {
    nextBtn: {
      height: '12px',
      width: '24px',
      minWidth: '24px',
      margin: '3px 0 0 3px',
      color: '#6A7070'
    },
    prevBtn: {
      height: '12px',
      width: '24px',
      minWidth: '24px',
      margin: '3px 3px 0 0',
      color: '#6A7070'
    }
  }
};

export default pearsonLightTheme;



// WEBPACK FOOTER //
// ./src/js/Themes/PearsonLightTheme.jsx